// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PPicCenterOutlinedSvg from "@fishx/icons-svg/es/asn/PPicCenterOutlined";
import FishxIcon from '../components/FishxIcon';

var PPicCenterOutlined = function PPicCenterOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PPicCenterOutlinedSvg
  }));
};

PPicCenterOutlined.displayName = 'PPicCenterOutlined';
export default React.forwardRef(PPicCenterOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PPicCenterOutlined.js
// module id = 3534
// module chunks = 0